const detectBrowserLanguage = () => {
  const userLang = navigator.language || navigator.userLanguage;
  console.log('Detected browser language:', userLang);
  return userLang.startsWith('hi') ? 'hi' : 'en';
};

export default detectBrowserLanguage;
